import PropTypes from "prop-types";


/**
 * @param {Array.<JSX.Element>} children
 * @param {string} name
 * @param {function} onClick
 * @param {boolean} disabled
 * @param {boolean} active
 * @returns {JSX.Element}
 * @constructor
 */
function Button({ children, name, onClick, disabled = false, active = false }) {

    const classes = [
        'esc-ii-w-full',
        'esc-ii-rounded-lg',
        'esc-ii-py-3',
        'esc-ii-flex',
        'esc-ii-flex-col',
        'esc-ii-items-center',
        'esc-ii-justify-center',
        'lg:esc-ii-max-w-[164.75px]',
        'lg:esc-ii-h-[76px]',
        ! active && ! disabled && 'esc-ii-shadow',
        active ? 'esc-ii-border-2' : 'esc-ii-border',
        active ? 'esc-ii-border-primary' : 'esc-ii-border-grey',
        'disabled:esc-ii-opacity-60',
    ];

    return (
        <button
            type="button"
            className={classes.filter(Boolean).join(' ')}
            onClick={onClick}
            disabled={disabled}
        >
            {children}
        </button>
    );
}

Button.PropTypes = {
    active: PropTypes.bool,
    name: PropTypes.string,
    onClick: PropTypes.func,
}

const Radio = ({ children }) => <>{children}</>;

const Group = ({ children }) => (
    <div className="esc-ii-flex esc-ii-flex-col esc-ii-space-y-2.5 lg:esc-ii-flex-row lg:esc-ii-space-y-0 lg:esc-ii-space-x-5">
        {children}
    </div>
);

Radio.Button = Button;
Radio.Group = Group;

export default Radio;
